// Shared right-hand affordances for the app's filter Selects/MultiSelects: a reset "x" once a
// value is picked, the dropdown chevron otherwise.
//
// Why hand-drawn instead of Mantine's `clearable` (which does exactly this out of the box): in this
// app neither icon renders - @uag/doka-design overrides the Combobox section styles, and the result
// is a select with no chevron and no way to clear it (see chat: "Man kann bei Systemen den Filter
// auch nicht 'resetten'"). Drawing both ourselves is the only reliable option; the same workaround
// SearchMask already used for Gruppe/Familie/System, lifted here so every filter select behaves the
// same way.

import { CloseButton } from '@mantine/core';

import type { ReactNode } from 'react';

/**
 * @param hasValue whether the control currently holds a value (single value set, or a non-empty
 * multi-select) - decides between the reset button and the chevron.
 * @param onReset clears the control; only reachable while `hasValue` is true.
 */
export const selectRightSection = (hasValue: boolean, onReset: () => void): ReactNode =>
    hasValue ? (
        <CloseButton size="sm" onClick={onReset} />
    ) : (
        <span className="material-symbols-outlined" style={{ color: 'var(--pih-muted)', fontSize: 18 }} aria-hidden>
            expand_more
        </span>
    );

/** Companion to {@link selectRightSection}: the section must only swallow clicks while it actually
 * carries the reset button, otherwise it would block opening the dropdown. */
export const selectRightSectionPointerEvents = (hasValue: boolean): 'all' | 'none' => (hasValue ? 'all' : 'none');
